/* CARVO — injects a 3-benefit strip into every showroom card. */
(function () {
  var ITEMS = [
    { t: 'משלוח מהיר', s: 'לכל הארץ',
      d: 'M3 7h11v8H3zM14 10h4l3 3v2h-7zM7 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z' },
    { t: 'אחריות לשנה', s: 'על פגמי ייצור',
      d: 'M12 2l8 3v6c0 5-3.4 9.2-8 11-4.6-1.8-8-6-8-11V5zM9 12l2 2 4-4' },
    { t: '14 יום', s: 'להחזרה',
      d: 'M3 12a9 9 0 1 0 3-6.7M3 4v5h5' }
  ];

  function strip() {
    var wrap = document.createElement('div');
    wrap.className = 'lmx__feats';
    ITEMS.forEach(function (it) {
      var cell = document.createElement('div');
      cell.className = 'lmx__feat';
      cell.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
        'stroke-linecap="round" stroke-linejoin="round"><path d="' + it.d + '"/></svg>' +
        '<span class="lmx__feat-t">' + it.t + '</span>' +
        '<span class="lmx__feat-s">' + it.s + '</span>';
      wrap.appendChild(cell);
    });
    return wrap;
  }

  function init() {
    document.querySelectorAll('[data-lmx-card]').forEach(function (card) {
      if (card.querySelector('.lmx__feats')) return;
      card.appendChild(strip());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
